import { ServiceRequestStatusMap } from "../../../model/service-request/service-request-instance";

const STATUS_LABELS: Partial<Record<string, string>> = {
	Unassigned: "Unassigned",
	Assigned: "Assigned",
	InProgress: "In Progress",
	Completed: "Completed",
};

export const getStatusText = (status: number): string | null => {
	const key = ServiceRequestStatusMap[status];
	return STATUS_LABELS[key] ?? null;
};
